import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { appTheme } from '../styles/theme';

const SessionSplash = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: appTheme.pageBg,
        color: appTheme.textMuted,
        fontWeight: 600,
        fontSize: '0.875rem',
      }}
    >
      {t('common.loading')}
    </div>
  );
};

interface RequireAuthProps {
  children: React.ReactNode;
  /** Where to send the user after sign-in, e.g. "/decks". */
  next: string;
}

/** Opens the login drawer when signed out; renders children once authenticated. */
const RequireAuth: React.FC<RequireAuthProps> = ({ children, next }) => {
  const { user, openLogin } = useAuth();

  useEffect(() => {
    if (user === null) {
      openLogin(next);
    }
  }, [user, next, openLogin]);

  if (user === undefined) {
    return <SessionSplash />;
  }

  if (user === null) {
    return <>{children}</>;
  }

  return <>{children}</>;
};

export default RequireAuth;
